import { render, staticRenderFns } from "./CardListRiwayatResep.vue?vue&type=template&id=b568ced2&scoped=true&"
import script from "./CardListRiwayatResep.vue?vue&type=script&lang=ts&"
export * from "./CardListRiwayatResep.vue?vue&type=script&lang=ts&"
import style0 from "./CardListRiwayatResep.vue?vue&type=style&index=0&id=b568ced2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b568ced2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VDivider,VIcon,VListItemContent,VProgressCircular,VRow})
